import { messagesRoot } from "./constants";

class ApiMessages {
  constructor(apiClass) {
    this.apiClass = apiClass;
  }

  getMessages = async (mailbox, fromDate, toDate) => {
    let params = { mailbox, fromDate, toDate };
    let apiRoute = messagesRoot;
    return this.apiClass.CallApi("get", apiRoute, params);
  };
}

export default ApiMessages;
